class GiftWrapping extends HTMLElement {
	constructor() {
		super();

		this.selectors = {
			detailsButton: ".wrap-options__details",
			checkboxWrapping: ".wrap-options__checkbox-element",
			wrappingModal: ".gift-wrapping__modal",
			header: ".theme__header",
			closeModalButton: ".wrapping-modal__close",
			wrappingContainer: ".gift-wrapping__container",
			productGiftNote: ".gift-wrapping__note",
			confirmMessageButton: ".wrapping-note__button",
			hiddenInputProduct: "product-gift-wrapping",
			checkbox: ".wrap-options__checkbox-element",
			productForm: 'form[data-product-form].product-form',
			addToCart: '.product__submit__item button[data-add-to-cart]',
			body: "body",
		};

		this.elements = {
			detailsButton: document.querySelector(this.selectors.detailsButton),
			checkboxWrapping: document.querySelector(
				this.selectors.checkboxWrapping,
			),
			wrappingModal: document.querySelector(this.selectors.wrappingModal),
			closeModalButton: document.querySelector(
				this.selectors.closeModalButton,
			),
			wrappingContainer: document.querySelector(
				this.selectors.wrappingContainer,
			),
			productGiftNote: document.querySelector(
				this.selectors.productGiftNote,
			),
			confirmMessageButton: document.querySelector(
				this.selectors.confirmMessageButton,
			),
			hiddenInputProduct: document.getElementById(
				this.selectors.hiddenInputProduct,
			),
			checkbox: document.querySelector(this.selectors.checkbox),
			addItemToCart: document.querySelector(this.selectors.addToCart),
			body: document.querySelector(this.selectors.body),
		};

		this.classes = {
			wrappingModalHidden: "gift-wrapping__modal--hidden",
			detailsButton: "wrap-options__details",
			closeModalButton: "wrapping-modal__close",
			checkbox: "wrap-options__checkbox-element",
			fixedBody: "fixed-body",
			hideHeader: "header__modal--hidden",
		};
	}

	connectedCallback() {
		this.addListeners();
	}

	addListeners() {
		if (this.elements.detailsButton) {
			document.body.addEventListener("click", (e) => {
				if (e.target.classList.contains(this.classes.detailsButton)) {
					this.showModal();

				} else if (e.target.classList.contains(this.classes.checkbox)) {
					if (e.target.checked) {
						this.showModal();

						if (e.target.dataset.valueText) {
							this.elements.productGiftNote.value =
								e.target.dataset.valueText;
						} else {
							this.elements.productGiftNote.value = "";
						}

						this.elements.wrappingModal.dataset.line =
							e.target.dataset.line;
						this.elements.confirmMessageButton.dataset.line =
							e.target.dataset.line;
					} else {
						this.removeGiftWrap();
					}
				}
			});
		}

		this.elements.confirmMessageButton.addEventListener("click", (e) => {
			this.closeModal();
			
			const valueInput = this.elements.productGiftNote.value;
			this.addGiftNote(valueInput)
			this.checkCheckbox();
		});

		this.elements.closeModalButton.addEventListener("click", () => {
			this.closeModal();
		});

		this.elements.wrappingModal.addEventListener("click", (e) => {
			const isClickInsideModal = this.elements.wrappingContainer.contains(
				e.target,
			);

			if (!isClickInsideModal) {
				this.closeModal();
			}
		});

		this.elements.addItemToCart.addEventListener('click', async (event) => {
			event.preventDefault();
			await this.resetPersonalization();
		})
	}

	addGiftNote(text){
		const productForm = document.querySelector(this.selectors.productForm);

		productForm.querySelector("input[name='properties[Gift message]']")
			? productForm.querySelector("input[name='properties[Gift message]']").remove()
			: '';

		productForm.querySelector("input[name='properties[Is Gift]']")
			? productForm.querySelector("input[name='properties[Is Gift]']").remove()
			: '';	

		if (text) {
			const inputText = document.createElement('input');
			const giftInput = document.createElement('input');

			inputText.type = 'hidden';
			inputText.name = 'properties[Gift message]';
			inputText.value = text;
			productForm.appendChild(inputText);

			giftInput.type = 'hidden';
			giftInput.name = 'properties[Is Gift]';
			giftInput.value = true;
			productForm.appendChild(giftInput);

			productForm.setAttribute('data-product-additional-property-gift-message', text);
			productForm.setAttribute('data-product-additional-property-gift-wrap', true);
		} else {
			const giftInput = document.createElement('input');

			giftInput.type = 'hidden';
			giftInput.name = 'properties[Is Gift]';
			giftInput.value = true;
			productForm.appendChild(giftInput);

			productForm.removeAttribute('data-product-additional-property-gift-message', '');
			productForm.setAttribute('data-product-additional-property-gift-wrap', true);
		}		
	}

	closeModal() {
		document.querySelector(this.selectors.header).classList.remove(this.classes.hideHeader);
		this.elements.wrappingModal.classList.add(
			this.classes.wrappingModalHidden,
		);

		this.elements.body.classList.remove(this.classes.fixedBody);
	}

	showModal() {
		document.querySelector(this.selectors.header).classList.add(this.classes.hideHeader);
		this.elements.wrappingModal.classList.remove(
			this.classes.wrappingModalHidden,
		);

		this.elements.body.classList.add(this.classes.fixedBody);
	}

	uncheckCheckbox() {
		this.elements.checkboxWrapping.checked = false;

	}

	checkCheckbox() {
		this.elements.checkboxWrapping.checked = true;
	}

	async removeGiftWrap() {
		const productForm = document.querySelector(this.selectors.productForm);
		productForm.querySelector("input[name='properties[Gift message]']")
				? productForm.querySelector("input[name='properties[Gift message]']").remove()
				: '';

		productForm.querySelector("input[name='properties[Is Gift]']")
		? productForm.querySelector("input[name='properties[Is Gift]']").remove()
		: '';	

		productForm.removeAttribute('data-product-additional-property-gift-message', '');
		productForm.removeAttribute('data-product-additional-property-gift-wrap', '');
		this.elements.productGiftNote.value = "";
		this.uncheckCheckbox();
	}

	async resetPersonalization(){
		setTimeout(() => {
		this.removeGiftWrap();
		}, 1500);
	}
}



if (!customElements.get("gift-wrapping")) {
	customElements.define("gift-wrapping", GiftWrapping);
}
